var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"item-type-icon gl-display-inline-block gl-text-secondary"},[_c('gl-icon',{attrs:{"name":_vm.iconClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }